import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@redux-devtools/ui';
import { TiUpload } from 'react-icons/ti';
import { importState } from '../../actions/index.js';
class ImportButton extends Component {
    constructor() {
        super(...arguments);
        this.mapRef = (node) => {
            this.fileInput = node;
        };
        this.handleImport = () => {
            this.fileInput.click();
        };
        this.handleImportFile = (e) => {
            const file = e.target.files[0];
            const reader = new FileReader();
            reader.onload = () => {
                this.props.importState(reader.result);
            };
            reader.readAsText(file);
            e.target.value = '';
        };
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        return (React.createElement(Button, { title: "Import from a file", onClick: this.handleImport },
            React.createElement(TiUpload, null),
            React.createElement("input", { type: "file", ref: this.mapRef, style: { display: 'none' }, onChange: this.handleImportFile })));
    }
}
const actionCreators = {
    importState,
};
export default connect(null, actionCreators)(ImportButton);
